import { defineComponent as _defineComponent } from 'vue'
import { ApiCameraWithIncludes } from '@eencloud/eewc-components/src/service/api-types'
import api from '@eencloud/eewc-components/src/service/api'
import { t } from '@/plugins/i18n';

import { useCamerasStore, useFloorsStore, useLocationsStore, useMessagingStore, useAppStore } from '@/stores'


export default /*#__PURE__*/_defineComponent({
  __name: 'EditFloorplanButtons',
  setup(__props) {

// EDIT
const floors = useFloorsStore()
const cameras = useCamerasStore()
const locations = useLocationsStore()
const messagingStore = useMessagingStore();
const appStore = useAppStore();

const onClickDone = () => {
  floors.$patch({
    isAddingCamerasToFloorplanActive: false,
    currentEditingCamera: undefined
  })
  floors.$patch({ isEditCamerasFloorEnabled: false })

}

function deleteCameraFromFloor(cameraToDelete: ApiCameraWithIncludes) {
  const deleteCameraWarningText = {
    title: 'Remove device from floor plan?',
    body: `You are going to remove ${cameraToDelete.name} from the floor plan.`,
    buttonMessage: 'Remove device'
  }
  messagingStore.deleteDialog({
    type: 'camera',
    item: cameraToDelete,
    deleteCallback: async () => {
      try {
        await api.editCameraDevicePosition({
          floor: null
        }, cameraToDelete.id)

        if (cameraToDelete.devicePosition && Number.isInteger(cameraToDelete.devicePosition.floor)) {
          cameraToDelete.devicePosition.floor = null

          const cameraPayloadIndex = cameras.cameras.findIndex((camera) => camera.id === cameraToDelete.id)
          cameras.$patch((state) => {
            state.cameras.splice(cameraPayloadIndex, 1, cameraToDelete)
          })

          floors.currentEditingCamera = null

          locations.setCurrentLocationCameras()
          floors.setCurrentFloorCameras()
          appStore.$patch({ addCamSidebarKey: appStore.addCamSidebarKey+1 });
        }
      } catch (error) {
        console.error(error)
      }
    },
  }, deleteCameraWarningText);
}

function openAddDevicesSidebar() {
  floors.$patch({
    isAddingCamerasToFloorplanActive: true,
    currentEditingCamera: undefined
  })
}

return { __sfc: true,floors, cameras, locations, messagingStore, appStore, onClickDone, deleteCameraFromFloor, openAddDevicesSidebar, t }
}

})